import PropertyItemList from './PropertyItemList';
import { PropertyItemListProps, PropertyItemListValueProps } from './types';

export type { PropertyItemListProps, PropertyItemListValueProps };
export default PropertyItemList;
